import { useCallback, useContext } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { OrderContext } from '../../OrderStore/index';

const CasesFilter = () => {
  const { filterConfigs, setFilterConfigs, caseArray } = useContext(OrderContext);

  const handleCasesUpdate = useCallback((selectedCases) => {
    setFilterConfigs({
      ...filterConfigs,
      cases: selectedCases.map((selectedCase) => selectedCase.id),
    });
  }, [filterConfigs, setFilterConfigs]);

  return (
    <div className="legs-filter-container justify-content-end mb-2">
      <div className="quick-adjustment">
        <Typeahead
          id="quick-adjustments-legs"
          className="quick-legs"
          labelKey="label"
          multiple
          onChange={handleCasesUpdate}
          options={caseArray}
          placeholder="Filter Case..."
          positionFixed
        />
      </div>
    </div>
  );
};

export default CasesFilter;
